function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Delete ",
        "?"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Delete ",
        "?"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Yes, Delete"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "No, Cancel"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Are you sure you want to delete ",
        "? ",
        " This action cannot be undone."
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Are you sure you want to delete ",
        "? This action cannot be undone."
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Archive ",
        "?"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Archive ",
        "?"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Yes, Archive"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "No, Cancel"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Are you sure you want to archive ",
        "? ",
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import { Typography } from "antd";
import React from "react";
import { t, jt } from "ttag";
import Modal from ".";
export var ActionType;
(function(ActionType) {
    ActionType["DELETE"] = "delete";
    ActionType["ARCHIVE"] = "archive";
})(ActionType || (ActionType = {}));
var generateDefaultLabels = function(param) {
    var _param_actionType = param.actionType, actionType = _param_actionType === void 0 ? ActionType.DELETE : _param_actionType, tmp = param.label, _ref = tmp === void 0 ? {
        singular: "Item"
    } : tmp, singular = _ref.singular, plural = _ref.plural, itemName = param.itemName, count = param.count, additionalInfo = param.additionalInfo;
    var formattedItemLabel = count > 1 ? /*#__PURE__*/ React.createElement(Typography.Text, {
        key: "itemLabel"
    }, count, " ", plural) : /*#__PURE__*/ React.createElement(Typography.Text, {
        key: "itemLabel",
        strong: true
    }, itemName);
    var _obj;
    return (_obj = {}, _defineProperty(_obj, ActionType.DELETE, {
        title: count > 1 && plural ? t(_templateObject(), plural) : t(_templateObject1(), singular),
        okText: t(_templateObject2()),
        cancelText: t(_templateObject3()),
        content: additionalInfo ? jt(_templateObject4(), formattedItemLabel, additionalInfo) : jt(_templateObject5(), formattedItemLabel)
    }), _defineProperty(_obj, ActionType.ARCHIVE, {
        title: count > 1 && plural ? t(_templateObject6(), plural) : t(_templateObject7(), singular),
        okText: t(_templateObject8()),
        cancelText: t(_templateObject9()),
        content: jt(_templateObject10(), formattedItemLabel, additionalInfo)
    }), _obj)[actionType];
};
var confirm = function(props) {
    var defaultLabels = generateDefaultLabels(props);
    var _props_title, _props_content, _props_cancelText, _props_okText;
    return Modal.confirm({
        title: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : defaultLabels.title,
        content: (_props_content = props.content) !== null && _props_content !== void 0 ? _props_content : defaultLabels.content,
        cancelText: (_props_cancelText = props.cancelText) !== null && _props_cancelText !== void 0 ? _props_cancelText : defaultLabels.cancelText,
        okText: (_props_okText = props.okText) !== null && _props_okText !== void 0 ? _props_okText : defaultLabels.okText,
        confirmDisabled: props.confirmDisabled,
        onOk: props.onDelete,
        onCancel: props.onCancel
    });
};
var DeleteModal = {
    confirm: confirm
};
export default DeleteModal;
